import { Grid } from '@gcl/react-core';
import * as React from 'react';
import { useDeepCompareEffectNoCheck } from 'use-deep-compare-effect';
import { BooleanFilterInput } from './FilterInput/BooleanFilterInput';
import { CheckboxGroupFilterInput } from './FilterInput/CheckboxGroupFilterInput';
import { DateTimeFilterInput } from './FilterInput/DateTimeFilterInput';
import { NumberFilterInput } from './FilterInput/NumberFilterInput';
import { SelectFilterInput } from './FilterInput/SelectFilterInput';
import { SelectWithSearchFilterInput } from './FilterInput/SelectWithSearchFilterInput';
import { StringFilterInput } from './FilterInput/StringFilterInput';
import { TextSelectFilterInput } from './FilterInput/TextSelectFilterInput';
import { IFilter, IFilterFieldConfig, SearchFilterType } from './searchFilter.models';
import './SearchFilter.scss';

export interface ISearchFilterProps {
  fieldConfigs: IFilterFieldConfig[];
  onFilterChanged: (filter: IFilter) => void;
  disabled?: boolean | undefined;
  defaultFilter?: IFilter;
}

export const SearchFilter: React.FunctionComponent<ISearchFilterProps> = ({
  fieldConfigs,
  onFilterChanged,
  disabled = false,
  defaultFilter = {},
}) => {
  const [localFilter, setLocalFilter] = React.useState<IFilter>(defaultFilter);
  const onFilterInputChanged = (fieldName: string, filter: any) => {
    setLocalFilter((old) => {
      return { ...old, [fieldName]: filter };
    });
  };

  useDeepCompareEffectNoCheck(() => {
    onFilterChanged(localFilter);
  }, [JSON.stringify(localFilter)]);

  useDeepCompareEffectNoCheck(() => {
    setLocalFilter(defaultFilter);
  }, [JSON.stringify(defaultFilter)]);

  const gerenateFilterInput = (fieldConfig: IFilterFieldConfig) => {
    const baseProps = { fieldConfig, onChange: onFilterInputChanged, filter: localFilter, disabled };
    switch (fieldConfig.type) {
      case SearchFilterType.Boolean:
        return <BooleanFilterInput {...baseProps} />;
      case SearchFilterType.DateTime:
        return <DateTimeFilterInput {...baseProps} />;
      case SearchFilterType.Number:
        return <NumberFilterInput {...baseProps} />;
      case SearchFilterType.SelectWithSearch:
        return <SelectWithSearchFilterInput {...baseProps} />;
      case SearchFilterType.Select:
        return <SelectFilterInput {...baseProps} />;
      case SearchFilterType.CheckboxGroup:
        return <CheckboxGroupFilterInput {...baseProps} />;
      case SearchFilterType.String:
        return <StringFilterInput {...baseProps} />;
      case SearchFilterType.TextSelect:
        return <TextSelectFilterInput {...baseProps} />;
      default:
        return <span />;
    }
  };

  return (
    <Grid container spacing={1} className="gcl-gems-search-filter-container">
      {fieldConfigs.map((fieldConfig, index) => {
        return (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className={`gcl-gems-search-filter-inner-container ${
              fieldConfig.type === SearchFilterType.DateTime ? 'date-filter-grid' : ''
            } ${fieldConfig.type === SearchFilterType.CheckboxGroup ? 'checkbox-group-filter-grid' : ''}`}
            key={`${fieldConfig.fieldName}_${index.toString()}`}
          >
            {gerenateFilterInput(fieldConfig)}
          </Grid>
        );
      })}
    </Grid>
  );
};
